// extracted by mini-css-extract-plugin
module.exports = {"root":"AspectRatio-module__root___AfpWK","wrapper":"AspectRatio-module__wrapper___ji2ya","inner":"AspectRatio-module__inner___a+URT"};